import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { ContentNews } from 'src/app/models/obs/contentnews';
import { News } from 'src/app/models/obs/news';
import { ContentnewsService } from 'src/app/services/obs/contentnews.service';
import { NewsService } from 'src/app/services/obs/news.service';
import { urlEndPoint } from 'src/app/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.component.html',
  styleUrl: './meeting.component.scss'
})
export class MeetingComponent implements OnInit {

  id: number = null;
  ns: News[] = [];
  e: News = null;

  cn: ContentNews[] = [];
  temp: ContentNews[] = [];
  msg: Message;
  URL: string = urlEndPoint;
  private safeUrlCache = new Map<string, SafeResourceUrl>();

  constructor(
    private sNews: NewsService,
    private SCNews: ContentnewsService,
    private actRoute: ActivatedRoute,
    private newsService: NewsService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getIdURL();
    this.getEv();
  }

  getEv() {
    this.sNews.getAllEv().subscribe(
      async res => {
        this.ns = res['data'];
        this.getContent4News();
      },
      err => { this.msg = err; }
    );
  }

  getContent4News() {
    this.temp = [];
    if (this.ns) {
      this.ns.forEach(o => {
        this.SCNews.get4News(o.id + '').subscribe(
          async res => {
            this.temp = res['data'];
            if (this.temp.length > 0) {
              this.temp.forEach(p => {
                // Añadir Contenidos a un array general
                this.cn.push(p);
              });
            }
          },
          err => { this.msg = err; }
        );
        this.setPrincipalNew(o);
      });
      //console.log("News: ", this.ns);
    }

  }

  getIdURL(): void {
    this.id = +this.actRoute.snapshot.paramMap.get('id');
  }

  setPrincipalNew(o: News) {
    if (o.id == +this.id) {
      this.getRelatedNews(o.tags);
      this.e = o;
    }
  }

  /**
 * Función que se ejecuta cuando se hace clic en el título de una noticia
 * @param id - ID de la noticia a la que se le hizo clic en el título
 */
  changeNew(id: number) {
    if (this.ns) {
      this.ns.forEach(o => {
        if (+id == o.id) {
          this.getRelatedNews(o.tags);
          this.e = o;
        }
      });
    }
    const element = document.getElementById("br-title");
    element.scrollIntoView({ behavior: 'smooth' });
  }

  //paginación
  pages: number = 1;
  //metodo para buscar las conincidencias de tags entre ficha(tier3) y noticias(news)
  tempRelated = {};
  news = [];
  newsFlag = 0;

  getRelatedNews(tags: string) {

    this.tempRelated['related'] = tags;
    const data = this.tempRelated
    /* console.log('este es el objeto', data); */

    this.newsService.getRelatedEvent(data).subscribe(
      res => {
        if (res['data'].length > 1) {
          this.newsFlag = 1;
          this.news = res['data'];
        } else {
          this.newsFlag = 0;
        }
        //console.log(this.news);

      },
      err => { console.error(err) }
    )
  }

  limitWords(content: string): string {
    let words = content.split(' ');
    if (words.length > 30) {
      words = words.slice(0, 30);
      content = words.join(' ') + '...';
    }
    return content;
  }

  getSafeUrl(url: string): SafeResourceUrl {
    if (!this.safeUrlCache.has(url)) {
      this.safeUrlCache.set(url, this.sanitizer.bypassSecurityTrustResourceUrl(url));
    }
    return this.safeUrlCache.get(url)!;
  }

  trackByUrl(index: number, url: string): string {
    return url;
  }

  getValidUrls(urls: string[]): string[] {
    return (urls || []).filter(url => url && url.trim() !== '');
  }
}
